import { Component, EventEmitter, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { HttpService, MessageService, SessionService, fileFormsParams, FileFormsService, fileInputParams, params, CombosConfiguration, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { Router, RouterEvent } from '@angular/router';

import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { Area } from 'src/app/models/administration/area';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';


@Component({
    selector: 'app-area-detail',
    templateUrl: './area-detail.component.html',
    styleUrls: ['./area-detail.component.scss'],
    standalone: false
})
export class AreaDetailComponent implements OnInit {

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Areas",
      router: '/administracion/areas',
    },
    {
      name: "Detalle",
      current: true
    }
  ]

  private urlGetDatosAreas: string = `${environment.endpoint}${EndpointDictionary.Area.CRUD_AREA_DATA}`
  private urlGetDatosUsuarios: string = `${environment.endpoint}${EndpointDictionary.User.USER_COMBO}`
  private size: number = ((screen.height + screen.width) / 2)
  private sizePicture: number
  private imageSrc
  private imagePH: string = null
  public file = null
  public formAreas: UntypedFormGroup
  private id_compania: number
  public tipoRedireccion: string

  public params: params[]

  public reloadComboUser = new EventEmitter<any>()
  public combosConfigUser: CombosConfiguration

  public fileInput: fileInputParams

  private paramsFile: fileFormsParams[] = [{
    id: 'old',
    value: ""
  }]

  private area: Array<Area>

  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpService,
    private message: MessageService,
    private router: Router,
    private session: SessionService,
    private formFile: FileFormsService,
    private deleteItem: DeleteGenericService,
    private storage: LocalStorageService,
  ) {
    this.tipoRedireccion = this.session.getData('redireccion')
    this.params = [
      {
        id: 'id_compania',
        value: this.storage.get<number>('id_compania')
      }]
    this.formAreas = this.formBuilder.group({
      imagen: '',
      nombre: '',
      codigo: '',
      responsable: '',
      descripcion: ''
    })

    this.fileInput = {
      input: 'vista',
      typeFile: 'imagen',
      edit: true,
      imageSrc: this.tipoRedireccion == 'actualizar' ? `${environment.endpoint}/api/v1${this.session.getData('dataArea')[0].imagen}` : '',
      style: {
        width: "100%",
        height: `${this.size * 0.3}px`,
        border: "1px solid black"
      }

    }
    this.combosConfigUser = {
      visibleField: 'nombre',
      selectionField: 'cedula',
      urlCombo: this.urlGetDatosUsuarios,
      urlParams: this.params,
      label: 'Responsable',

    }
  }

  ngOnInit(): void {

    this.message.openLoading('Cargando', 'Cargando')
    this.id_compania = this.storage.get<number>('id_compania')
    this.tipoRedireccion = this.session.getData('redireccion')
    this.initializeFields()
  }

  initializeFields() {

    if (this.session.getData('redireccion') == 'actualizar') {

      this.area = this.session.getData('dataArea')


      this.imageSrc = `${environment.endpoint}/api/v1${this.area[0].photo}`
      this.imagePH = this.area[0].photo
      this.file = this.area[0].photo
      // console.log("Area",this.area)
      //console.log("responsable",this.area[0].responsable)


      for (let controls of Object.keys(this.formAreas.controls)) {
        this.formAreas.get(controls).setValue(this.area[0][controls].toString())
      }

      this.paramsFile[0].value = this.area[0].photo
      this.combosConfigUser.selected = this.area[0].responsible
      this.reloadComboUser.emit("selected")
    }
    this.message.closeLoading()
  }

  ValueIDUser($event) {
    if ($event && $event > 0) {
      this.formAreas.get('responsable').setValue($event)
    }
  }

  fileChange($event: Event | RouterEvent) {
    ////console.log($event)
    if ($event['compressor']) {
      this.file = $event['compressor'];
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(this.file);
    } else {
      this.file = $event['new'];
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(this.file);
    }
  }
  async save(form) {

    if (this.tipoRedireccion == "nuevo") {
      this.message.openLoading('Cargando', 'Creando area')
      if (this.file == null) {
        this.message.closeLoading()
        console.log('no se agrego foto')
      } else {
        this.message.closeLoading()
        let formFoto: FormData = this.formFile.createMultipartForm(this.file)
        let res: BaseResponse<GenericResponse> = await this.http.postDataPromise(`${environment.endpoint}${EndpointDictionary.Docs.DOCS_SUBIR}`, formFoto)
        form.imagen = res['body']
      }


      form.id_compania = this.id_compania

      this.http.postData(`${this.urlGetDatosAreas}`, form).subscribe(
        (res: BaseResponse<GenericResponse>) => {
          if (res['code'] === 0) {
            this.message.SuccessToast('Area creada correctamente')
            this.message.closeLoading()
            setTimeout(() => {
              this.router.navigate(['administracion/areas'])
            }, 500);
          } else {
            this.message.closeLoading()
            this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['message']}`)
          }
        },
        err => {
          this.message.closeLoading()
          this.message.Error('Error!', err.message)
        }
      )


      // console.log("furmulario",form)

    } else {
      this.message.openLoading('Cargando', 'Actualizando area')
      form.id = this.session.getData('dataArea')[0]['id']
      form.id_compania = this.id_compania

      if (this.imagePH == this.file) {
        console.log('no se actualizo la foto')
      } else {
        let formFoto = this.formFile.createMultipartForm(this.file, this.paramsFile)
        let res: BaseResponse<GenericResponse> = await this.http.postDataPromise(`${environment.endpoint}${EndpointDictionary.Docs.DOCS_SUBIR}`, formFoto)
        form.imagen = res['body']
        console.log('se actualizo la foto')

      }

      //console.log("furmulario",form)

      this.http.putData(`${this.urlGetDatosAreas}`, form).subscribe(
        (res: BaseResponse<GenericResponse>) => {
          if (res['code'] === 0) {
            this.message.SuccessToast('Area actualizada correctamente')
            this.message.closeLoading()
            setTimeout(() => {
              this.router.navigate(['administracion/areas'])
            }, 500);


          } else {
            this.message.closeLoading()
            this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['body']['sqlMessage']}`)
          }
        },
        err => {
          this.message.closeLoading()
          this.message.Error('Error', err.message)
        }

      )

    }


  }

  errorMessage() {

  }

  async deleteArea($event) {
    $event.preventDefault()
    //console.log("Event",$event)
    let res = await this.deleteItem.deleteD(this.area, this.urlGetDatosAreas, "id", "Area")
    // console.log("respuesta",res)
    if (res) {
      this.router.navigate(['administracion/areas'])
    }
  }

  back($event) {
    $event.preventDefault()
    setTimeout(() => {
      this.router.navigate(['administracion/areas'])
    }, 1000);
  }

}






